<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 用户表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <el-button v-if="formData.creater_id === operator_id || editable === '是'" type="primary" size="mini" plain round icon="em-icon-save" @click="saveHandler">提交保存</el-button>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <!--表单-->
      <el-form ref="form" :model="formData" size="mini" label-width="80px" style="width: 350px;">
        <!--字段-->
        <el-form-item label="用户名" required>
          <el-input placeholder="用户名" v-model="formData.display_code"></el-input>
        </el-form-item>
        <el-form-item label="关联员工">
          <el-input placeholder="请选择" v-model="formData.employee_name" clearable>
            <el-button slot="append" icon="el-icon-search" @click="showEmployeeDialogHandler"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="关联角色" required>
          <el-select v-model="formData.role_id" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in roles" :key="item.id" :label="item.role_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input placeholder="备注" v-model="formData.remark"></el-input>
        </el-form-item>
        <el-form-item label="初始密码">123456</el-form-item>
      </el-form>
    </div>
    <!-- 选择员工对话框 -->
    <ezz-dialog-employee ref="employeeDialog" width="500px" :parent="this" />
  </el-dialog>
</template>

<script>
import EzzDialogEmployee from '@/views/dialogs/CheckOneEmployee.vue'
export default {
  name: 'UserDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        display_code: '',
        employee_id: '',
        employee_name: '',
        role_id: '',
        remark: '',
        creater_id: '',
        updater_id: ''
      },
      roles: [],
      operator_id: sessionStorage.getItem('operator_id'),
      editable: this.$store.state.editable
    }
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getUser, { UserId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.user !== null) {
          _this.formData = _json.user
          console.log(_this.formData)
        } else {
          _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          _this.formData.creater_id = _this.operator_id
        }
        _this.roles = _json.roles
      })
    },
    // 用于父窗体新增
    addHandler: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
    },
    editHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
    },
    // 关闭事件
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    // 打开员工选择对话框
    showEmployeeDialogHandler: function () {
      this.$refs.employeeDialog.open()
    },
    // 选择员工，赋值员工信息
    setEmployeeInfo: function (_employeeID, _employeeName) {
      this.formData.employee_id = _employeeID
      this.formData.employee_name = _employeeName
    },
    // 保存方法
    saveHandler: function () {
      let _this = this
      if (_this.validationHandler(_this.formData.display_code, _this.formData.role_id)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveUser, _this.formData, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '操作成功',
              type: 'success'
            })
            _this.isShow = false
            _this.parent.loadData()
          } else if (_json.status === 'existed') {
            _this.$message({
              message: '该用户名已经存在',
              type: 'error'
            })
          } else {
            _this.$message({
              message: '操作失败',
              type: 'error'
            })
          }
        })
      }
    },
    // 验证
    validationHandler: function (rawCode, roleId) {
      let _this = this
      if (rawCode === '') {
        _this.$message({
          type: 'error',
          message: '用户名不能为空'
        })
        return false
      }

      if (roleId === '') {
        _this.$message({
          type: 'error',
          message: '关联角色不能为空'
        })
        return false
      }

      return true
    }
  },
  components: {
    EzzDialogEmployee
  }
}
</script>
